import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { V2AuthConfirmationAbstract } from '@app/+login/deprecated-hybrid/components/v2-auth-confirmation.abstract.component';
import { IdentifierType } from '@app/core/_models/member-interface';
import { MemberService, PublicInfoResponse } from '@app/core/members/member.service';
import { TranslatePipe } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { MsisdnOTPComponent } from '@app/+login/deprecated-hybrid/views/otp-login-confirmation/msisdn-otp/msisdn-otp.component';
import { EmailOTPComponent } from '@app/+login/deprecated-hybrid/views/otp-login-confirmation/email-otp/email-otp.component';

@Component({
  selector: 'app-login-confirmation',
  templateUrl: './login-confirmation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: `:host::ng-deep {
    .login-v2.login-v2-auth {
      .panel-heading.card-header {
        padding-top: 15px;
        padding-bottom: 15px;
      }
    }
  }`,
  imports: [
    TranslatePipe,
    AsyncPipe,
    AccordionModule,
    MsisdnOTPComponent,
    EmailOTPComponent,
    RouterLink,
  ],
})
export class OtpLoginConfirmationComponent extends V2AuthConfirmationAbstract implements OnInit {
  public readonly identifiers = IdentifierType;
  public availableIdentifiers$: Observable<string[]>;

  constructor(router: Router,
              route: ActivatedRoute,
              cdr: ChangeDetectorRef,
              private memberService: MemberService) {
    super(router, route, cdr);
  }

  public ngOnInit(): void {
    super.ngOnInit();

    if (this.identifier) {

      this.availableIdentifiers$ = this.memberService.isMember(this.identifier)
        .pipe(map((publicInfo: PublicInfoResponse) => publicInfo.available_identifiers));
    }
  }
}
